import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaAttentionHeader'

type IcaAttentionHeaderProps = React.JSX.IntrinsicElements['tgdb-ica-attention-header']

export const IcaAttentionHeader = wrapWc<IcaAttentionHeaderProps>('tgdb-ica-attention-header', [])
